import {Component, Inject} from '@angular/core';
import {Localization} from '../../../../common/enums/localization';
import {ChecklistsService} from "../../../../common/services/checklists.service";
import {UntypedFormControl, Validators} from "@angular/forms";
import {ChecklistNode} from "../../checklist/model/checklist-node";
import {concat} from "rxjs";
import {finalize, takeUntil, tap} from "rxjs/operators";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-duplicate-multiple-times-modal',
  templateUrl: './duplicate-multiple-times-modal.component.html',
  styleUrls: ['./duplicate-multiple-times-modal.component.scss']
})
export class DuplicateMultipleTimesModalComponent {
  public readonly Localization = Localization;

  public readonly amountField = new UntypedFormControl(1, [Validators.min(1), Validators.required]);

  public copiesMade = 0;
  public isCopying = false;

  constructor(
    private readonly self: MatDialogRef<Self>,
    private readonly checklists: ChecklistsService,
    @Inject(MAT_DIALOG_DATA) private readonly data: DuplicateMultipleTimesData

  ) {}

  public get originalName(): string {
    return this.data.original.label;
  }

  public get desiredAmountOfCopies(): number {
    return this.amountField.value as number;
  }

  public get showPerformanceWarning(): boolean {
    return this.desiredAmountOfCopies > 20;
  }

  public get progress(): number {
    return this.copiesMade / this.desiredAmountOfCopies * 100;
  }

  public cancel() {
    this.self.close(false);
  }

  public duplicate() {
    this.isCopying = true;
    this.self.disableClose = true;
    this.makeCopies().pipe(
      finalize(() => this.self.close(true)),
    ).subscribe();
  }

  private makeCopies() {
    const operations = new Array(this.desiredAmountOfCopies).fill(this.copy());
    return concat(...operations).pipe(
      takeUntil(this.self.beforeClosed()),
    );
  }

  private copy() {
    const {id, parentId} = this.data.original;
    const operation = this.checklists.duplicateNode(id, parentId);
    return operation.pipe(
      tap(() => this.copiesMade++),
    );
  }

}

export interface DuplicateMultipleTimesData {
  original: ChecklistNode;
}


type Self = DuplicateMultipleTimesModalComponent;
